import {css} from '@emotion/react'

export const CFInputCSS = {
	borderRadius: '3px',
	border: '1px solid hsl(0, 0%, 80%)',
	height: '1.5em',
	height5x: '7.5em',
	focus: {
		outline: 'none',
		border: '1px solid #2684FF',
		boxShadow: '#2684FF 0 0 0 1px',
	},
	background: '#ffffff',
	color: '#000000',
	disabled: {
		background: '#e9e9e9',
		color: '#888888',
	},
} as const

export const cssCFInputBorder = css`
	border-radius: ${CFInputCSS.borderRadius};
	border: ${CFInputCSS.border};
`
export const cssCFInputBorderFocussed = css`
	outline: none;
	border-radius: ${CFInputCSS.borderRadius};
	border: ${CFInputCSS.focus.border};
	box-shadow: ${CFInputCSS.focus.boxShadow};
`
export const cssCFInputBorderWhenFocussed = css`
	:focus {
		outline: none;
		border-radius: ${CFInputCSS.borderRadius};
		border: ${CFInputCSS.focus.border};
		box-shadow: ${CFInputCSS.focus.boxShadow};
	}
`
export const cssCFSlct = css`
	height: ${CFInputCSS.height};

	& input {
		font-size: 1em;
	}
`
export const cssCFSlctLarge = css`
	height: ${CFInputCSS.height5x};

	& input {
		font-size: 1em;
	}
`
export const cssCFInput = css`
	height: ${CFInputCSS.height};
	padding: 3px 4px;
	border-radius: ${CFInputCSS.borderRadius};
	border: ${CFInputCSS.border};
	box-sizing: border-box;
	width: 100%;
	font-size: 1em;

	& input {
		font-size: 1em;
	}

	&:focus {
		outline: none;
		border: ${CFInputCSS.focus.border};
		box-shadow: ${CFInputCSS.focus.boxShadow};
	}

	&:disabled {
		background: ${CFInputCSS.disabled.background};
		color: ${CFInputCSS.disabled.color};
	}
`
